export const PIE_CHART_COLOR_SCHEME = {
  GREEN: 'GREEN',
  BLUE: 'BLUE',
  PURPLE: 'PURPLE',
};

export const PIE_CHART_SEGMENTS_MAP = {
  DEFAULT: 'DEFAULT',
};

const COLOR_SCHEMES = {
  [PIE_CHART_COLOR_SCHEME.GREEN]: {
    900: '#004D40',
    800: '#00695C',
    700: '#00796B',
    500: '#009688',
    400: '#26A69A',
    200: '#80CBC4',
    100: '#B2DFDB',
    50: '#E0F2F1',
  },
  [PIE_CHART_COLOR_SCHEME.BLUE]: {
    900: '#1A237E',
    800: '#283593',
    700: '#303F9F',
    500: '#3F51B5',
    400: '#5C6BC0',
    200: '#9FA8DA',
    100: '#C5CAE9',
    50: '#E8EAF6',
  },
  [PIE_CHART_COLOR_SCHEME.PURPLE]: {
    900: '#4A148C',
    800: '#6A1B9A',
    700: '#7B1FA2',
    500: '#9C27B0',
    400: '#AB47BC',
    200: '#CE93D8',
    100: '#E1BEE7',
    50: '#F3E5F5',
  },
};

const SEGMENTS = {
  [PIE_CHART_SEGMENTS_MAP.DEFAULT]: {
    1: [900],
    2: [900, 700],
    3: [900, 700, 400],
    4: [900, 700, 400, 200],
    5: [900, 700, 400, 200, 100],
    6: [900, 700, 400, 200, 100, 50],
    7: [900, 700, 500, 400, 300, 200, 50],
    8: [900, 800, 700, 500, 400, 200, 100, 50],
  },
};

const _getMaxSegmentsCount = (segmentsMap) => {
  const segments = SEGMENTS[segmentsMap] || {};
  return Object.keys(segments)[Object.keys(segments).length - 1];
};

const _getSegmentsMapValues = (segmentsMap, segmentsCount) => {
  const maxSegmentCount = _getMaxSegmentsCount(segmentsMap);
  const segmentCountTemp = segmentsCount > maxSegmentCount ? maxSegmentCount : segmentsCount;
  return SEGMENTS[segmentsMap] && SEGMENTS[segmentsMap][segmentCountTemp];
};

export const getPieChartSegmentColors = (
  colorSchemeName,
  segmentsCount,
  segmentsMap = PIE_CHART_SEGMENTS_MAP.DEFAULT
) => {
  if (!colorSchemeName || !segmentsCount || segmentsCount < 1) {
    return [];
  }

  const colorShades = COLOR_SCHEMES[colorSchemeName];
  const colorShadesNumbers = _getSegmentsMapValues(segmentsMap, segmentsCount);

  if (!colorShades || !colorShadesNumbers) {
    return [];
  }

  const result = [];
  colorShadesNumbers.forEach((shadeNumber) => {
    const color = colorShades[shadeNumber];
    if (color) {
      result.push(color);
    }
  });

  return result;
};
